import React, {useState, useEffect, lazy, Suspense} from 'react';
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from 'gatsby'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import * as recipeCardStyles from './recipeCard.module.scss'
import * as blogPageStyles from '../templates/blogPage.module.scss'
import Ratings from 'react-ratings-declarative';
import Switch from 'react-switch'
import Pinterest from '../images/pinterest2.svg'
// import postscribe from 'postscribe';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import humanizeDuration from 'humanize-duration'; 

import ExitIntent from "../utils/ExitIntent"
const EmailForm = lazy(() => import('../components/emailForm'))
const ExitIntentModal = lazy(() => import('../components/ExitIntentModal'))

const RecipeCard = ({ recipe, rating, ratingQty, calories, fat, satFat, cholest, sodium, carbs, fiber, sugar, protein, vitA, vitB12, vitC, vitD, calc, iron, potas, zinc }) => {

  const config = {
    thresholds: [
      { l: 's', r: 1 },
      {1: 'ss', r: 59},
  { l: 'm', r: 1 },
  { l: 'mm', r: 119, d: 'minute' },
  { l: 'h', r: 1 },
  { l: 'hh', r: 23, d: 'hour' },
  { l: 'd', r: 1 },
  { l: 'dd', r: 29, d: 'day' },
  { l: 'M', r: 1 },
  { l: 'MM', r: 11, d: 'month' },
  { l: 'y' },
  { l: 'yy', d: 'year' }
  ]
  }
  
  dayjs.extend(relativeTime, config)
  dayjs.extend(duration)
  dayjs.extend(updateLocale)

dayjs.updateLocale('en', {
   
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'n/a',
        m: "n/a",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      
      }, 
}) // Your Day.js locale Object.

  

  // state

  let [measurementUnits, setMeasurementUnits] = useState(recipe.defaultMeasurements || "US")
  let [photosOn, setPhotosOn] = useState(true)
  let [showPopup, setShowPopup] = useState(false)

  const onChange = () => {
    measurementUnits === "US" ? 
    setMeasurementUnits("Metric")
   : setMeasurementUnits("US")
  }

  const onChangePhotos = () => {
    photosOn === true ?
    setPhotosOn(false) :
    setPhotosOn(true)
  }

  // exit intent popup modal

  useEffect(() => {
    if (document.cookie.indexOf("modal_seen=true") < 0) {
    const removeExitIntent = ExitIntent({
      threshold: 30,
      eventThrottle: 100,
      onExitIntent: () => {
        setShowPopup(true)
      },
    })
    return () => {
      removeExitIntent()
    }
  }
  })

//   amazon
// useEffect(() =>{
//     if (recipe.amazonProductCode !== null && typeof window !== `undefined`) {
//       postscribe('#amazon', recipe.amazonProductCode.amazonProductCode)}
//   }, [recipe.amazonProductCode])

    return (
      <div id="recipe" className={recipeCardStyles.recipe}>
        <Suspense fallback={<div>Loading...</div>}>
        <ExitIntentModal show={showPopup} />
        </Suspense>
       
              <h2 className={recipeCardStyles.recipeTitle}>{recipe.blogTitle}</h2>
              
                {!!rating === true ? 
                  <div className={recipeCardStyles.rating}>
                    <Ratings
                      rating={rating}
                      widgetDimensions="20px"
                      widgetSpacings="5px"
                      widgetRatedColors="rgb(255,102,0)"
                    >
                      <Ratings.Widget  />
                      <Ratings.Widget />
                      <Ratings.Widget  />
                      <Ratings.Widget  />
                      <Ratings.Widget />
                    </Ratings>
                  <span className={recipeCardStyles.ratingText}>{rating.toFixed(2)} stars from {ratingQty} reviews</span>
                </div> : <div></div>
              }
              
              <div className={recipeCardStyles.recipeInfo}>
                <p className={recipeCardStyles.recipeInfoYield}>
                  <span className={recipeCardStyles.recipeInfoHeading}>Yield</span>
                  {recipe.recipeYield}
                </p>
                <p className={recipeCardStyles.recipeInfoPrepTime}>
                  <span className={recipeCardStyles.recipeInfoHeading}>Prep Time</span>
                  
                  
                  {humanizeDuration(dayjs.duration(recipe.prepTime), { units: ["h", "m"]})}
                </p>
                <p className={recipeCardStyles.recipeInfoCookTime}>
                  <span className={recipeCardStyles.recipeInfoHeading}>Cook Time</span>
                  {humanizeDuration(dayjs.duration(recipe.cookTime), { units: ["h", "m"]})}
                </p>
                <p className={recipeCardStyles.recipeInfoTotalTime}>
                  <span className={recipeCardStyles.recipeInfoHeading}>Total Time</span>
                  {humanizeDuration(dayjs.duration(recipe.totalTime), { units: ["h", "m"]})}
                </p>
              </div>
              <div className={blogPageStyles.btnContainer} id="recipeButtons">
                <div className={`btn-color ${blogPageStyles.btnOutline}`} id={blogPageStyles.marginRight}>
                  <Link className={blogPageStyles.jumpButton} to={`/print/${recipe.slug}`}>Print it</Link>
                </div>
                <div className={`btn-color ${blogPageStyles.btnOutline}`}>
                <OutboundLink 
                  className={blogPageStyles.jumpButton} 
                  target="_blank" 
                  rel="noreferrer noopener" 
                  href="https://www.pinterest.com/pin/create/button/" 
                  data-pin-do="buttonBookmark"
                  data-pin-media={recipe.pinterestImage.imgixImage.url}>
                  <Pinterest className={blogPageStyles.socialIcon} />Pin it
                </OutboundLink>
                  
                </div>
              </div>
             
              <div className={recipeCardStyles.recipeIngredients}>
                <div className={recipeCardStyles.recipeIngredientsInnerBox}>
                  <div className={recipeCardStyles.recipeIngredientsHeadingBox}>
                  <h3 className={recipeCardStyles.recipeIngredientsHeading}>Ingredients</h3>
                  <label htmlFor="Units" className={recipeCardStyles.toggleSwitchContainer}>
                      
                      <Switch 
                      onChange={onChange} 
                      checked={measurementUnits === "Metric"}
                      offColor="#ffcc00"
                      onColor ="#ffcc00"
                      uncheckedIcon={<div>US</div>}
                      checkedIcon={<div className={recipeCardStyles.switchOn}>Metric</div>}
                      width={85}
                      id="Units"
                      />
                      <span className={`${recipeCardStyles.toggleSwitchLabel} ${recipeCardStyles.toggleSwitchLabelHideMobile}`}>Units of Measurement</span>
                    </label>
                  </div>
                  <div className={recipeCardStyles.recipeIngredientsRichText}>
                    
                    
                    {
                      recipe.recipeIngredientGroup.map((group) => {
                        return <div key={group.contentful_id}>
                          {!!group.groupName ? <h4>{group.groupName}</h4> : <span></span>}
                          <ul>
                          {group.ingredients.map((ingredient) => {
                            return <li key={ingredient.contentful_id}>
                              {/* If there's an affiliate link, display the ingredient with the link */}
                              {!!ingredient.ingredient.affiliateLink ? 
                              <div>
                              
                                {measurementUnits === "US" ? 
                              <span>{!!ingredient.usMeasurement ? <span>{ingredient.usMeasurement} {!!ingredient.usUnit ? ingredient.usUnit : <span></span>} {!!ingredient.addlUsMeasurement ? `plus ${ingredient.addlUsMeasurement} ${ingredient.addlUsUnit} ` : <span></span>}</span> : <span></span>}</span> : 
                              <span>{!!ingredient.metricMeasurement ? <span>{ingredient.metricMeasurement} {!!ingredient.metricUnit ? `${ingredient.metricUnit} ` : <span></span>}</span> : <span></span>}</span>}
                              <OutboundLink href={ingredient.ingredient.affiliateLink} rel="nofollow, noreferrer" target="_blank">
                                  {!!ingredient.replacementIngredientName ? ingredient.replacementIngredientName : ingredient.ingredient.ingredientName}
                              </OutboundLink> 
                              {!!ingredient.preparationModifiers ? ingredient.preparationModifiers : <span></span>}
                              
                              </div>
                              : <span></span>}
                              {/* If there's an external link to another recipe, display the link */}
                              {!!ingredient.ingredient.externalLink ? 
                              <div>
                              {measurementUnits === "US" ? 
                              <span>{!!ingredient.usMeasurement ? <span>{ingredient.usMeasurement} {!!ingredient.usUnit ? ingredient.usUnit : <span></span>} {!!ingredient.addlUsMeasurement ? `plus ${ingredient.addlUsMeasurement} ${ingredient.addlUsUnit} ` : <span></span>}</span> : <span></span>}</span> :                                
                              <span>{!!ingredient.metricMeasurement ? <span>{ingredient.metricMeasurement} {!!ingredient.metricUnit ? `${ingredient.metricUnit} ` : <span></span>}</span> : <span></span>}</span>}
                              <OutboundLink href={ingredient.ingredient.externalLink} target="_blank" rel="noreferrer" >
                                  {!!ingredient.replacementIngredientName ? ingredient.replacementIngredientName : ingredient.ingredient.ingredientName}
                              </OutboundLink>
                              {!!ingredient.preparationModifiers ? ingredient.preparationModifiers : <span></span>}
                              </div> : <span></span>}
                              {/* If there's an internal link, display the ingredient with the link */}
                              {!!ingredient.ingredient.internalLink ? 
                              <div>
                                {measurementUnits === "US" ? 
                              <span>{!!ingredient.usMeasurement ? <span>{ingredient.usMeasurement} {!!ingredient.usUnit ? ingredient.usUnit : <span></span>} {!!ingredient.addlUsMeasurement ? `plus ${ingredient.addlUsMeasurement} ${ingredient.addlUsUnit} ` : <span></span>}</span> : <span></span>}</span> : 
                              <span>{!!ingredient.metricMeasurement ? <span>{ingredient.metricMeasurement} {!!ingredient.metricUnit ? `${ingredient.metricUnit} ` : <span></span>}</span> : <span></span>}</span>}
                              <Link to={`/${ingredient.ingredient.internalLink.category[0].slug}/${ingredient.ingredient.internalLink.slug}`}  target="_blank">
                                
                              {!!ingredient.replacementIngredientName ? ingredient.replacementIngredientName : ingredient.ingredient.ingredientName}
                              </Link>
                              {!!ingredient.preparationModifiers ? ingredient.preparationModifiers : <span></span>}
                              </div>
                              : <span></span>}
                              {/* If there's no link, display in standard text */}
                              {!ingredient.ingredient.affiliateLink && !ingredient.ingredient.externalLink && !ingredient.ingredient.internalLink ? <span>{measurementUnits === "US" ? 
                              <span>{!!ingredient.usMeasurement ? <span>{ingredient.usMeasurement} {!!ingredient.usUnit ? ingredient.usUnit : <span></span>} {!!ingredient.addlUsMeasurement ? `plus ${ingredient.addlUsMeasurement} ${ingredient.addlUsUnit} ` : <span></span>}</span> : <span></span>}</span> :                                 
                              <span>{!!ingredient.metricMeasurement ? <span>{ingredient.metricMeasurement} {!!ingredient.metricUnit ? `${ingredient.metricUnit} ` : <span></span>}</span> : <span></span>}</span>}
                              {!!ingredient.replacementIngredientName ? ingredient.replacementIngredientName : ingredient.ingredient.ingredientName}
                              
                              {!!ingredient.preparationModifiers ? ingredient.preparationModifiers : <span></span>}</span> : <span></span>}
                              
                              </li>
                          })}
                          </ul>
                        </div>
                      })
                    }
                  

                  </div> 
                  
                  </div>
              </div>
              {/* {recipe.amazonProductCode !== null ? 
              <div id="amazon" className={blogPageStyles.amazon}></div>
             
              :<div></div>}  */}
            
            

              <div>
                <div className={recipeCardStyles.recipeInstructionsHeadingBlock}>
                <h3 className={recipeCardStyles.recipeInstructionsHeading}>Instructions</h3>
                <label id={recipeCardStyles.photosLabel} htmlFor="Photos" className={recipeCardStyles.toggleSwitchContainer}>
                       
                <Switch 
                      onChange={onChangePhotos} 
                      checked={photosOn === true}
                      uncheckedIcon={<div>off</div>}
                      checkedIcon={<div className={recipeCardStyles.switchOn}>on</div>}
                      width={65}
                      id="Photos"
                      />
                      <span className={recipeCardStyles.toggleSwitchLabel}>Recipe Photos</span> 
                    </label>
                    </div>
                <ol className={recipeCardStyles.recipeInstructionsList}>
                  {recipe.recipeInstructions.map((instruction) => {
                    return (
                      <li className={recipeCardStyles.recipeInstruction} key={instruction.contentful_id}>
                        <div className={recipeCardStyles.recipeInstructionText} dangerouslySetInnerHTML={{
                          __html: instruction.text.childMarkdownRemark.html
                        }}></div>
                        {instruction.image !== null && photosOn === true ? 
                        <div className={recipeCardStyles.recipeImageBlock}>
                          <GatsbyImage
                            image={instruction.image.imgixImage.gatsbyImageData}
                            alt={instruction.image.title} />
                          <div className={recipeCardStyles.recipeImageCaption}>
                            {instruction.image.description}
                          </div>
                        </div> : <div></div>}
                      </li>
                    );
                  })}
                </ol>
              </div>
              <div className={recipeCardStyles.recipeNotes}>
                <h3 className={recipeCardStyles.recipeNotesHeading}>Notes & Hints</h3>
                <div className={recipeCardStyles.recipeNotesInnerBox}>
                {recipe.recipeNotes.map((note) =>{
                  return <p className={recipeCardStyles.recipeNote} key={note}>{note}</p>
                })}
                </div>
              </div>
              
              <div className={recipeCardStyles.nutritionBox}>
                <h3>Nutrition Data</h3>
                <span>Serving Size: </span> {recipe.servings === 1 ? recipe.servings : `1/${recipe.servings} of`} recipe;&nbsp;
                <span>Calories: </span> {calories};&nbsp;
                <span>Fat: </span> {fat} g.;&nbsp;
                <span>Saturated Fat: </span> {satFat} g.;&nbsp;
                <span>Cholesterol: </span> {cholest} mg.;&nbsp;
                <span>Sodium: </span> {sodium} mg.;&nbsp;
                <span>Carbohydrates: </span> {carbs} g.;&nbsp;
                <span>Fiber: </span> {fiber} g.;&nbsp;
                <span>Sugar: </span> {sugar} g.;&nbsp;
                <span>Protein: </span> {protein} g.;&nbsp;
                <span>Vitamin A: </span> {vitA} mcg. RAE;&nbsp;
                <span>Vitamin B12: </span> {vitB12} mcg.;&nbsp;
                <span>Vitamin C: </span> {vitC} mg.;&nbsp;
                <span>Vitamin D: </span> {vitD} mcg.;&nbsp;
                <span>Calcium: </span> {calc} mg.;&nbsp;
                <span>Iron: </span> {iron} mg.;&nbsp;
                <span>Potassium: </span> {potas} mg.;&nbsp;
                <span>Zinc: </span> {zinc} mg.
                <p><span>Note:</span> This data should be used only as an estimate. <Link to="/terms">Please see the nutrition section of my terms and conditions for more information on how this data is calculated.</Link></p>
              </div>
              <Suspense fallback={<div>Loading...</div>}>
              <EmailForm />
              </Suspense>
            <div>
            <GatsbyImage
              image={recipe.bottomImage.imgixImage.gatsbyImageData}
              alt={recipe.bottomImage.title} />
          </div>
            </div>
    );
}

export default RecipeCard